import { render, staticRenderFns } from "./TheModalTratamiento.vue?vue&type=template&id=e3636ca2&scoped=true&"
import script from "./TheModalTratamiento.vue?vue&type=script&lang=js&"
export * from "./TheModalTratamiento.vue?vue&type=script&lang=js&"
import style0 from "./TheModalTratamiento.vue?vue&type=style&index=0&id=e3636ca2&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3636ca2",
  null
  
)

export default component.exports